import React from 'react';
import { Button } from './ui/Button';
import { TextReveal } from './ui/Reveal';
const NUMBERS = [{
  value: '50+',
  label: 'Clients served'
}, {
  value: '500+',
  label: 'Projects shipped'
}, {
  value: '5+',
  label: 'Years in Nairobi'
}, {
  value: '7',
  label: 'People on the team'
}];
export function Studio() {
  return <section id="studio" className="relative z-10 w-full bg-[#F2F2F2] px-5 py-20 lg:px-8 lg:py-24" data-id="element-207" data-mp="3ddq0cx7z6ssv">
      <div className="mx-auto w-full max-w-shell" data-id="element-208" data-mp="3r41tmzgaqxll">
        <div className="flex flex-col justify-between gap-8 lg:flex-row lg:items-end" data-id="element-209" data-mp="3m7bececbg618">
          <h2 className="max-w-[720px] text-3xl font-semibold leading-tight text-[#2D2D2D] lg:text-[40px] lg:leading-[48.8px]" data-id="element-210" data-mp="4yelxvmzmprn">
            <TextReveal data-id="element-211" data-mp="mybdtdlpt9">Shaping the Future of Digital Marketing</TextReveal>
          </h2>
          <Button to="/#contact" variant="solid" data-id="element-212" data-mp="26p9nl43vlj6a">
            Work with us
          </Button>
        </div>

        <p className="mt-8 max-w-[720px] text-base leading-7 text-[#595959] lg:text-lg" data-id="element-213" data-mp="21rzyjpkef9iz">
          Seven people in Nairobi who care a lot about the details most studios
          skip. We work in small, senior teams — no hand-offs to juniors, no
          design-by-committee. When we're done, you own a brand that's easy to
          run without us.
        </p>

        <ul className="mt-10 grid grid-cols-2 gap-6 lg:grid-cols-4" data-id="element-214" data-mp="6lfih2pdoo1s">
          {NUMBERS.map(item => <li key={item.label} className="flex flex-col gap-2 rounded-2xl bg-white p-6" data-id="element-215" data-mp="bl2522r3jgn9">
              <p className="text-3xl font-bold text-[#0000FE] lg:text-4xl" data-id="element-216" data-mp="gik6l82satl8">
                {item.value}
              </p>
              <p className="text-sm font-medium leading-6 text-[#6F6F6F]" data-id="element-217" data-mp="km9r9mgc8r0z">
                {item.label}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}